import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28">
      <div className="w-full max-w-[800px] mx-auto px-6 md:px-10 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
          准备好探索17c了吗？
        </h2>
        <p className="text-foreground-600 max-w-[500px] mx-auto mb-8 leading-relaxed">
          立即加入数百万用户的行列，体验17c带来的高效数字工作方式。免费注册，无需信用卡。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/getting-started"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            免费开始使用
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-foreground-200 text-foreground-700 rounded-md text-sm font-medium hover:border-primary-300 hover:text-primary-500 transition-all whitespace-nowrap cursor-pointer"
          >
            联系销售团队
          </Link>
        </div>
      </div>
    </section>
  );
}